import * as React from 'react';

import * as styles from './NotFound.css';

export const NotFound: React.FC = () => {
  return <div className={styles['container']}>В данной области ничего не найдено</div>;
};
